import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.13 32.695a7.103 7.103 0 0 1-7.092-6.72 25.905 25.905 0 0 1 0-2.796 7.103 7.103 0 0 1 7.092-6.72h3.531l1.565-1.76a61.435 61.435 0 0 1 7.505-7.134l1.117-.896a3.044 3.044 0 0 1 4.936 2.096c.4 4.341.598 9.611.598 15.813 0 6.199-.199 11.467-.598 15.807a3.044 3.044 0 0 1-4.938 2.095l-1.169-.94a62.016 62.016 0 0 1-7.6-7.243l-1.417-1.602h-3.53Zm23.028 2.11a1.015 1.015 0 1 1-1.41-1.46 12.136 12.136 0 0 0 3.723-8.763 12.14 12.14 0 0 0-3.787-8.825 1.015 1.015 0 0 1 1.398-1.471A14.165 14.165 0 0 1 37.5 24.582c0 3.907-1.586 7.563-4.342 10.223Z",
    fill: "currentColor"
  }));
};

var SvgSoundLow = styled(SvgComponent).withConfig({
  displayName: "SoundLow__SvgSoundLow",
  componentId: "sc-1k4bige-0"
})(["", " ", ""], size, color);
export default SvgSoundLow;